import {
reactive,
ref,
} from "@vue/composition-api";
import store from "@/store";
import { privilegeCodeTemplateModel } from "@/models/privilege/privilege-code-template";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";

export default function useImportUpdateCus(){

  const {
    openDefaultErrorModal,
    openSuccessModal,
  } = useValidationModal();

  const loading = reactive({
    form: false,
  });


  const {
      ImportUpdateCustomer,
  } = privilegeCodeTemplateModel();

  const formFile = reactive({
    name: "",
    file: null,
  });

  const canUpload = ref(false);

  const onUpload = (file) => {
    formFile.name = file.name;
    formFile.file = file.file;

    if(file) canUpload.value = true;
  };

  const downloadTemplate = () => {
    window.location.href = "https://devbcrminternal.blob.core.windows.net/privilege-contianer/Template/Code_Template_New.xlsx"
  }

  const fetchInportUpdateCustomer = () => {
    loading.form = true;
    let payload = {
      Import_File: formFile.file,
    };
    ImportUpdateCustomer.payload = payload;
    store
      .dispatch("api/apiFormRequest", ImportUpdateCustomer)
      .then((response) => {
        openSuccessModal("ทำรายการสำเร็จ !");
      })
      .catch((error) => {
        openDefaultErrorModal(error);
      })
      .finally(() => {
        loading.form = false;
      });
  };

  return{
    loading,
    formFile,
    canUpload,
    onUpload,
    downloadTemplate,
    fetchInportUpdateCustomer,
  }
}